// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// TAILSCALE EGRESS PROXY SCHEMA
/////////////////////////////////////////

export const TailscaleEgressProxySchema = z.object({
  url: z.string(),
  noProxy: z.string().nullable(),
})

export type TailscaleEgressProxy = z.infer<typeof TailscaleEgressProxySchema>

export default TailscaleEgressProxySchema;
